/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlUserShareResponse
 */
export interface ControlUserShareResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlUserShareResponse
     */
    share_new_users: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlUserShareResponse
     */
    share_existing_users: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlUserShareResponse
     */
    share_failed: Array<string>;
}

/**
 * Check if a given object implements the ControlUserShareResponse interface.
 */
export function instanceOfControlUserShareResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "share_new_users" in value;
    isInstance = isInstance && "share_existing_users" in value;
    isInstance = isInstance && "share_failed" in value;

    return isInstance;
}

export function ControlUserShareResponseFromJSON(json: any): ControlUserShareResponse {
    return ControlUserShareResponseFromJSONTyped(json, false);
}

export function ControlUserShareResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUserShareResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'share_new_users': json['share_new_users'],
        'share_existing_users': json['share_existing_users'],
        'share_failed': json['share_failed'],
    };
}

export function ControlUserShareResponseToJSON(value?: ControlUserShareResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'share_new_users': value.share_new_users,
        'share_existing_users': value.share_existing_users,
        'share_failed': value.share_failed,
    };
}

